import {
	Directive,
	ElementRef,
	Input,
	OnInit,
	Renderer2,
	Inject
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { PermissionService } from '../services/permission.service';
import { ContentService } from '../services/content.service';

@Directive({
	selector: '[sdmPermission]'
})
export class SdmPermissionDirective implements OnInit {
	@Input('sdmPermission') permission!: string;

	constructor(
		@Inject(ElementRef) private el: ElementRef,
		@Inject(Renderer2) private renderer: Renderer2,
		@Inject(PermissionService) private permissionService: PermissionService,
		@Inject(MatDialog) private dialog: MatDialog,
		@Inject(ContentService) private content: ContentService
	) { }

	ngOnInit(): void {
		// Add safety check
		if (!this.permission) {
			return;
		}


		const permissionsPromise = this.permissionService.getCurrentPermissions();
		if (!permissionsPromise) {
			// User not authenticated, hide the element
			this.renderer.setStyle(this.el.nativeElement, 'display', 'none');
			return;
		}

		permissionsPromise.then((response: any) => {
			const permissions = response?.permissions;
			if (!permissions) {
				console.warn('SdmPermissionDirective: No permissions received from service');
				return;
			}

			const hasPermission =
				!!permissions[this.permission] ||
				(!!permissions['Tenant.*'] && !this.permission.includes('GlobalAdmin')) ||
				!!permissions['GlobalAdmin.*'];


			if (!hasPermission) {
				const element = this.el.nativeElement;
				// Always hide elements that don't have permission
				this.renderer.setStyle(element, 'display', 'none');
			}
		}).catch(err => {
			console.error('SdmPermissionDirective: Permission check failed:', err);
		});
	}
}

